module.exports = __webpack_public_path__ + "static/Dillons_pin_hover-8b67b8836556a7f28db5835ae7cb0ee1.png";